import React from 'react'
import { Paper } from '@mui/material'
import PropTypes from 'prop-types'

const BG_COLORS = {
	black: 'text.primary',
	grey: 'text.secondary',
	ivory: 'text.white',
	yellow: 'primary.main',
	white: 'white',
	none: 'transparent',
}

const Zone = ({ bgcolor, mb, children, pb, pt, color, id, ...rest }) => {
	return (
		<Paper
			sx={(theme) => ({
				...rest,
				bgcolor: BG_COLORS[color],
				color: 'white',
				textAlign: 'center',
				borderRadius: 0,
				p: (theme) => theme.spacing(10),
				pb,
				pt,
				mb,
				[theme.breakpoints.down('md')]: {
					px: 2,
				},
			})}
			id={id}
		>
			{children}
		</Paper>
	)
}
Zone.defaultProps = {
	color: 'white',
}

Zone.propTypes = {
	color: PropTypes.string,
	children: PropTypes.node.isRequired,
}
export default Zone
